import { Gift } from '@/entities/cart'

import { Modal } from '@/shared/ui'
import { Heading } from '@/shared/ui/heading'

import { GiftProductCard } from '../gift-product-card/gift-product-card'

import cl from './gifts-catalog-modal.module.scss'

type GiftsCatalogModalProps = {
	productId: number
	gifts: Gift[]
	isOpen: boolean
	onClose: () => void
}

export const GiftsCatalogModal = (props: GiftsCatalogModalProps) => {
	const { productId, gifts, isOpen, onClose } = props

	return (
		<Modal isOpen={isOpen} onClose={onClose} variant="inset" contentClassName={cl.gifts}>
			<Heading preset="h2" className={cl.gifts__heading}>
				Выберите подарок
			</Heading>
			<div className={cl.gifts__gridWrapper}>
				<div className={cl.gifts__grid}>
					{gifts.map(gift => (
						<GiftProductCard key={gift.ID} productId={productId} type="wideOnMobile" adaptive gift={gift} />
					))}
				</div>
			</div>
		</Modal>
	)
}
